// libs
import { useApolloClient } from 'hooks/useApolloClient'
// types
import {
  IRiskResponse,
  IRiskCreateInput,
  IRiskUpdateInput,
  IMutationResponse,
  IRiskDeleteMutationArgs,
  IRiskUpdateMutationArgs,
  IRiskCreateMutationArgs,
  IRiskCreatePublicMutationArgs
} from 'types/graphql'
// graphql
import {
  RISK_CREATE_MUTATION,
  RISK_DELETE_MUTATION,
  RISK_UPDATE_MUTATION,
  RISK_CREATE_PUBLIC_MUTATION
} from 'graphql/risk/mutations'
// utils
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

export const useRisksAPI = () => {
  const { client } = useApolloClient()

  const createRisk = async (input: IRiskCreateInput) => {
    try {
      const response = await client.mutate<Record<'riskCreate', IRiskResponse>, IRiskCreateMutationArgs>({
        mutation: RISK_CREATE_MUTATION,
        variables: {
          input
        }
      })

      return response.data.riskCreate.data
    } catch (e) {
      console.log('[useRisksAPI.createRisk]', parseGraphQLErrorMessages(e))
    }
  }

  const createPublicRisk = async (variables: { domain: string; input: IRiskCreateInput }, accessToken: string) => {
    try {
      const response = await client.mutate<Record<'riskCreatePublic', IRiskResponse>, IRiskCreatePublicMutationArgs>({
        mutation: RISK_CREATE_PUBLIC_MUTATION,
        variables,
        context: {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      })

      return response.data.riskCreatePublic.data
    } catch (e) {
      console.log('[useRisksAPI.createPublicRisk]', parseGraphQLErrorMessages(e))
    }
  }

  const updateRisk = async (id: string, input: IRiskUpdateInput) => {
    try {
      await client.mutate<IMutationResponse, IRiskUpdateMutationArgs>({
        mutation: RISK_UPDATE_MUTATION,
        variables: {
          id,
          input
        }
      })
    } catch (e) {
      console.log('[useRisksAPI.updateRisk]', parseGraphQLErrorMessages(e))
    }
  }

  const deleteRisk = async (id: string) => {
    try {
      await client.mutate<IMutationResponse, IRiskDeleteMutationArgs>({
        mutation: RISK_DELETE_MUTATION,
        variables: {
          id
        }
      })
    } catch (e) {
      console.log('[useRisksAPI.deleteRisk]', parseGraphQLErrorMessages(e))
    }
  }

  return {
    createRisk,
    updateRisk,
    deleteRisk,
    createPublicRisk
  }
}
